









































































import Vue from 'vue'
import SeismicForm from '@/models/SeismicForm'
import PointsParticuliers from '@/components/SeismicInsepctionForm/_PointsParticuliers.vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'SimpleTrunk4',
  components: {
    PointsParticuliers
  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  watch: {
    form () {
      console.log('Trunk 3 2 watch', '---')
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis4.rightHolderFixing)
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis4.actionForGC)
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis4.rightExpansionPin)
      console.log('Trunk 3 2 watch', this.form.analysis.simpleTrunkAnalysis4.postSeismicREXisApplied)
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapGetters(['getIsPrintablePDFMode'])
  },
  data () {
    return {
      specificPoints: [] as Array<string>
    }
  },
  mounted () {
    this.$forceUpdate()
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },
  methods: {

  }
})

